import { Fade } from 'helpers/animation';
import useFormInput from 'hooks/form/useFormInput';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import {
  DESKTOP_MIN_WIDTH,
  REGISTER_FISTNAME_NAME,
  REGISTER_LASTNAME_NAME,
  REGISTER_MIDDLENAME_NAME,
} from '../../../../../constants';

const customFormInputStyleMobile = {};

const customFormInputStyle = {
  [REGISTER_FISTNAME_NAME]: {
    width: 'calc(50% - 12px)',
    float: 'left',
    marginRight: '12px',
    zIndex: 1,
  },
  [REGISTER_MIDDLENAME_NAME]: {
    width: 'calc(50% - 12px)',
    float: 'left',
    marginLeft: '12px',
    zIndex: 1,
  },
  [REGISTER_LASTNAME_NAME]: {
    width: '100%',
    float: 'left',
    zIndex: 1,
  },
};

const FormInputValidation = ({
  ref,
  field,
  information,
  setInformation,
  validation,
  setValidation,
  checkFormInputValidation,
}) => {
  const { t } = useLang();
  const { isDesktop } = useDetectDevice();

  const {
    inputRef,
    resetFormInput,
    setInformationFormInput,
    setValidationFormInput,
    getValueTrim,
    FormLabel,
    FormControlFeedback,
  } = useFormInput(field);

  const handleOnChange = (e) => {
    const { value, name } = e.target;
    const valueTrim = getValueTrim(value, true);

    if (!valueTrim) {
      // resetFormInput({
      //   information,
      //   setInformation,
      //   validation,
      //   setValidation,
      // });
      let newInformation = setInformationFormInput({
        value: '',
        information,
        setInformation,
      });
      setValidationFormInput({
        validation,
        setValidation,
        checkFormInputValidation: () =>
          checkFormInputValidation(
            newInformation[name],
            field,
            newInformation,
            validation
          ),
      });
      return;
    }

    let newInformation = setInformationFormInput({
      value: valueTrim,
      information,
      setInformation,
    });

    setValidationFormInput({
      validation,
      setValidation,
      checkFormInputValidation: () =>
        checkFormInputValidation(
          newInformation[name],
          field,
          newInformation,
          validation
        ),
    });
  };
  const handleOnBlur = (e) => {
    handleOnChange(e);
  };

  return (
    <FormGroupStyled
      style={
        !isDesktop
          ? customFormInputStyleMobile[field.name]
          : customFormInputStyle[field.name]
      }
    >
      <FormLabel />
      <FormControl
        ref={ref}
        type={field.type}
        name={field.name}
        value={information ? information[field.name] : ''}
        placeholder={field.placeholder ? t(field.placeholder) : ''}
        isInvalid={validation[field.name]}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        readOnly={field?.isReadOnly}
      />
      <FormControlFeedback value={t(validation[field.name])} />
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 32px;
  position: relative;
  ${Fade};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 34px;
  }
`;

const FormControl = styled(Form.Control)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;

  color: var(--ds-c-grey-dark);
  height: 44px;
  border: 1px solid var(--ds-c-grey-light);
  border-radius: 12px;
  padding-inline: 10px;
  background: var(--ds-c-white);

  &:focus {
    border: 1px solid var(--ds-c-grey-dark) !important;
    outline: none !important;
    box-shadow: none !important;
  }

  &:invalid,
  &:invalid:focus {
  }
  &.is-invalid {
    border: 1px solid var(--ds-c-red) !important;
    outline: none !important;
    box-shadow: none !important;
    background-image: none !important;
    padding-inline: 10px !important;
  }

  &[readonly] {
    border: none !important;
  }

  &::placeholder {
    font-family: var(--ff-primary);
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    text-transform: none;

    color: var(--ds-c-blue-disabled) !important;

    @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
      font-size: 16px;
      line-height: 20px;
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

export default FormInputValidation;
